import React from 'react';
import { withWrapper } from '@shared/react';
import {
    ISOReportsTableProvider,
    useISOReportsTable,
    getISOReportsTableColumns,
    PAYMENT_REQUESTS_TABLE_TITLE,
    PAYMENT_REQUESTS_TABLE_INFO_URL,
} from './lib';
import { Table } from '@features/Table';
import { ISOReportsTableFilters } from './components';
import './ISOReportsTable.scss';
import { getISOReportsTableRows } from './lib/getISOReportsTableRows';

const ISOReportTableContent: React.FC = () => {
    const { isoReports, isoReportsLoading, paginationOptions, onISOReportViewClick } = useISOReportsTable();

    return (
        <Table
            columns={getISOReportsTableColumns()}
            data={isoReports}
            dataLoading={isoReportsLoading}
            tableTitle={PAYMENT_REQUESTS_TABLE_TITLE}
            infoLink={PAYMENT_REQUESTS_TABLE_INFO_URL}
            paginationOptions={paginationOptions}
            filters={<ISOReportsTableFilters />}
            row={getISOReportsTableRows({ onISOReportViewClick })}
        />
    );
};

export const ISOReportsTable = withWrapper(ISOReportsTableProvider)(ISOReportTableContent);
